define([
	"dojo/_base/declare",
	"csi/state",
	"csi/session",
	"csi/table/Widget"
], function(declare, state, session, Widget) {

	return declare(Widget, {
		/**
		 * @override
		 * return object containing properties from view necessary to recreate it for printing that are not custom view options
		 */
		getPrintProperties() {
			var params = this.inherited(arguments);
			params.printDesignColors = this.printDesignColors;
			return params;
		},

		/**
		 * @override
		 * set the printDesignColors filter to PrintDesignColors parameter from Java operation
		 */
		postMixInProperties() {
			if (state.get("print") && !state.get("printAdHoc")) {
				this.printDesignColors = session.getLocationValue("PrintDesignColors")?.split(",");
			}

			this.inherited(arguments);
		}
	});
});